import { Component, OnChanges, SimpleChanges, inject } from '@angular/core';
import {
    IAddToBasketErrorEvent,
    ProductAddToBasketComponentDef
} from '@df/catalog-ui/product/add-to-basket/product-add-to-basket.component.def';
import { Client } from '@df/core/service/client';
import { ScrollToService } from '@df/dom/scroll/scroll-to.service';
import { AttributeLabelPipeService } from '@df/ui/common/attribute-label.pipe';
import { TranslationService } from '@df/ui/translation/translation.service';
import { ActionComponent } from '../../../ui/api/action.component';
import { ResultComponent } from '../../../ui/api/result.component';
@Component({
    selector: 'product-view-add-to-basket',
    templateUrl: 'product-view-add-to-basket.html',
    standalone: true,
    imports: [ResultComponent, ActionComponent]
})
export class ProductViewAddToBasketComponent extends ProductAddToBasketComponentDef implements OnChanges {
    private _addedToBasket: boolean = false;
    private addedToBasketTimeout?: number;
    private attributeLabelPipeService = inject(AttributeLabelPipeService);
    protected translationService = inject(TranslationService);
    private client = inject(Client);

    protected scrollToService = inject(ScrollToService);

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['product'] || changes['productId']) {
            this.addedToBasket = false;
        }
    }
    get addedToBasket(): boolean {
        return this._addedToBasket;
    }
    set addedToBasket(value: boolean) {
        this._addedToBasket = value;
        this.detectChanges();
        this.clearAddedToBasketTimeout();
        if (value) {
            this.addedToBasketTimeout = this.timeoutService.setTimeout(() => {
                this.addedToBasket = false;
                this.detectChanges();
            }, 5000);
        }
    }
    private clearAddedToBasketTimeout(): void {
        if (this.addedToBasketTimeout) {
            clearTimeout(this.addedToBasketTimeout);
            this.addedToBasketTimeout = undefined;
        }
    }
    /**
     * Retrieves error message for missing configurations
     */
    private getConfigurationWarning(): string | undefined {
        if (this.product?.isConfigurable) {
            const attrs = this.product.configurableAttributeCodes;
            return attrs?.length === 1
                ? this.translationService.transform('Select %', this.attributeLabelPipeService.execute(attrs[0]))
                : this.translationService.transform('Select options');
        }
        return undefined;
    }
    /**
     * Gets a warning for temp OOS problem
     */
    private getTempStockWarning(): string | undefined {
        if (this.product?.isTempOutOfStock) {
            return 'Notify me';
        }
        return undefined;
    }
    protected getButtonLevelWarning(): string | undefined {
        return this.getConfigurationWarning() || this.getTempStockWarning();
    }
    protected getIfAddedToBasket(): string | undefined {
        if (this.addedToBasket) {
            return this.translationService.transform('Added to basket');
        }
    }
    /**
     * Checks if button should be disabledd
     * enabled when warnign is presnet, and disabled when no warninrg but error
     */
    get isDisabled(): boolean {
        return !this.getButtonLevelWarning() && !this.isSalable;
    }
    /**
     * Retrieves button copy
     */
    get buttonCopy() {
        return this.getButtonLevelWarning() || this.getIfAddedToBasket() || this.translationService.transform('Add to basket');
    }
    onQtyChange() {
        this.detectChanges();
    }
    override _submit() {
        if (this.getConfigurationWarning()) {
            if (this.client.isS || this.client.isM) {
                this.scrollToService.scrollTo('#pdpConfigurableOptions', { offset: 100 });
            }
        } else if (this.getTempStockWarning()) {
            alert('Implement notification!');
        } else {
            super._submit();
        }
    }
    protected override onSuccess(): void {
        super.onSuccess();
        this.addedToBasket = true;
    }
    protected override onError(errorEvent: IAddToBasketErrorEvent): void {
        super.onError(errorEvent);
        this.addedToBasket = false;
    }
}
